export const cashinStatus = {
    Started: 'Started',
    Activated: 'Activated',
    AuthorizationRequired: 'AuthorizationRequired',
    Approved: 'Approved',
    PaidOut: 'PaidOut',
    Acked: 'Acked',
    Rejected: 'Rejected'
};
